import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { validateEmail } from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { InputField } from "../../../../Components/formElements/InputField";
import CustomerItemService from "../../../../services/customer_v2_appCommonService";
import toast from "react-hot-toast";

const SendEmailModalV2 = React.forwardRef((props, ref) => {
  const { data } = props;

  const [formData, setFormData] = useState({
    loadingAdviceNr: "",
    email: "",
    // companyName: "",
  });

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getErrorFields, setErrorFields] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [disable, setDisabled] = useState(false);

  useEffect(() => {
    if (props.show && data?.loadingAdviceNr) {
      setFormData({
        loadingAdviceNr: data.loadingAdviceNr,
        email: "",
      });
    }
  }, [props.show, data]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    const requiredFields = [];

    if (!formData.email) {
      requiredFields.push("* Email is required.");
    } else if (!validateEmail(formData.email)) {
      requiredFields.push("* Invalid email address.");
    }

    if (requiredFields.length > 0) {
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    setDisabled(true);
    try {
      await CustomerItemService.sendEmailForLoading(formData).then((item) => {
        if (item?.status === 200) {
          // console.log("item", item);
          toast.success(`Mail Sent ${item?.message}` || "Mail send successfully", {
            duration: 2000,
            position: "top-right",
          });
        } else {
          console.error("Failed to send invitation:");
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setDisabled(false);
    }

    // props?.onSubmit(formData);
    props?.onHide();
  };
  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  useEffect(() => {
    // Reset form when modal is closed
    if (!props.show) {
      setFormData({
        loadingAdviceNr: "",
        email: "",
      });
    }
  }, [props.show, setFormData]);

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="lg"
      ref={ref}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Send Email</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col>
            <InputField
              className="inputBox"
              label="Godown Address"
              name="godownAddressDescription"
              id="godownAddressDescription"
              extraLabel=""
              placeholder="First Name"
              value={data?.items[0]?.godownAddressDescription || ""}
              // onChange={handleChange}
              disabled={true}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <InputField
              className="inputBox"
              label="Loading AdVice Nr"
              name="loadingAdviceNr"
              id="loadingAdviceNr"
              extraLabel=""
              placeholder="First Name"
              value={data?.loadingAdviceNr || ""}
              // onChange={handleChange}
              disabled={true}
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <InputField
              className="inputBox"
              label="Email"
              name="email"
              id="email"
              extraLabel=""
              placeholder="test@gmail.com"
              value={formData.email || ""}
              onChange={handleChange}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={handleSubmit}
          disabled={disable}
          className="btn btn-primary"
        >
          Submit
        </button>
        <button onClick={props?.onHide} className="btn btn-danger">
          Cancel
        </button>
      </Modal.Footer>

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </Modal>
  );
});

export default SendEmailModalV2;
